var map = {
	"./Icones Antigos/1-icone.svg": 7916,
	"./Icones Antigos/2-icone.svg": 5918,
	"./Icones Antigos/3-icone.svg": 5040,
	"./Icones Antigos/4-icone.svg": 2527,
	"./cancelar-icone.svg": 4555,
	"./concluido-icone.svg": 5322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1149;